<form *ngIf="form" class="row" [formGroup]="form">

    <mat-form-field>
        <mat-label>
            Nome
        </mat-label>
        <buffered-input formControlName="nome"></buffered-input>
    </mat-form-field>

    <mat-form-field>
        <mat-label>
            Via / piazza
        </mat-label>
        <buffered-input formControlName="via"></buffered-input>
    </mat-form-field>

    <mat-form-field>
        <mat-label>
            N. civico
        </mat-label>
        <buffered-input formControlName="civico"></buffered-input>
    </mat-form-field>
    <mat-form-field>
        <mat-label>
            CAP
        </mat-label>
        <buffered-input formControlName="cap"></buffered-input>
    </mat-form-field>

    <mat-form-field>
        <mat-label>
            Comune
        </mat-label>
        <comune-picker formControlName="comune"></comune-picker>
    </mat-form-field>

    <mat-form-field>
        <mat-label>
            P. IVA
        </mat-label>
        <buffered-input formControlName="partita_iva"></buffered-input>
    </mat-form-field>

    <mat-form-field>
        <mat-label>
            Codice Fiscale
        </mat-label>
        <buffered-input formControlName="codice_fiscale"></buffered-input>
    </mat-form-field>

</form>
